import { render, staticRenderFns } from "./IncidentAdmin.vue?vue&type=template&id=d95dabde&scoped=true"
import script from "./IncidentAdmin.vue?vue&type=script&lang=js"
export * from "./IncidentAdmin.vue?vue&type=script&lang=js"
import style0 from "./IncidentAdmin.vue?vue&type=style&index=0&id=d95dabde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d95dabde",
  null
  
)

export default component.exports